import { render, staticRenderFns } from "./FaqPage.vue?vue&type=template&id=595996ba&scoped=true"
import script from "./FaqPage.vue?vue&type=script&lang=js"
export * from "./FaqPage.vue?vue&type=script&lang=js"
import style0 from "./FaqPage.vue?vue&type=style&index=0&id=595996ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595996ba",
  null
  
)

export default component.exports